module.exports = __webpack_public_path__ + "pc/img/about_sens.c715f787.webp";